/**
 * Funding-source persistence used inside the module.
 *
 * `upsertSelfFundingSource` is the plain `PUT /client/:clientId/multiple-funding-source` for one
 * self-funding source (pass `null` data to delete it). It is not tied to any flow: guided planning,
 * the D2C sequence and partner sharing all save sources through it.
 */
import { WaterlilyClient } from '@client/api/waterlily';

export function upsertSelfFundingSource(params: {
  clientId: string;
  fundingSourceId: string | null;
  fundingSourceData: SelfFundingSource | null;
}) {
  return WaterlilyClient.put<PutMultipleFundingSourceResponse>(
    `/client/${params.clientId}/multiple-funding-source`,
    {
      clientId: params.clientId,
      fundingSourceId: params.fundingSourceId,
      fundingSourceType: 'selfFunding',
      fundingSourceData: params.fundingSourceData,
    },
  );
}
